import { SHOW_MESSAGE, CLOSE_MESSAGE, SHOW_SUCCESS_BAR, CLOSE_SUCCESS_BAR } from './types'

const SUCCESS_BAR_DURATION_MS = 5000;
let successBarTimeout: ReturnType<typeof setTimeout> | null = null;

const show_Message = (messageCategory: number, title: string, subTitle: string) => {

    // 0 = neutral
    // 1 = positive
    // 2 = negative
    // 3 = info

    return {
        type: SHOW_MESSAGE,
        messageCategory: messageCategory,
        title: title,
        subTitle: subTitle,
    }
}

export const closeMessage = () => {
  return {
    type: CLOSE_MESSAGE
  }
}

export const showMessage = (messageCategory: number, title: string, subTitle: string) => {
    return (dispatch: any) => {
        setTimeout(() => dispatch(closeMessage()), 3000);
        dispatch(show_Message(messageCategory, title, subTitle))
    }
}

export const closeSuccessBar = () => {
  return {
    type: CLOSE_SUCCESS_BAR
  }
}

export const showSuccessBar = (title: string, text: string) => {
    return (dispatch: any) => {
        // restart the timer so a new message always stays visible for the full duration
        if (successBarTimeout) {
            clearTimeout(successBarTimeout);
        }
        successBarTimeout = setTimeout(() => dispatch(closeSuccessBar()), SUCCESS_BAR_DURATION_MS);
        dispatch({ type: SHOW_SUCCESS_BAR, title, text })
    }
}
